import styled from 'styled-components'

import { ReactComponent as ArchiveBoxIconUnstyled } from '@sketch/icons/archive-box-24-svg'

export const Button = styled.button`
  display: flex;
  align-items: center;
  height: 38px;
  padding: 0 35px; /* stylelint-disable-line scales/space */
  margin: 7px auto 7px; /* stylelint-disable-line scales/space */
  font-size: ${({ theme }) => theme.fontSizes.E};
  color: ${({ theme }) => theme.colors.foreground.secondary.A};
  background: ${({ theme }) => theme.colors.background.secondary.A};
  cursor: pointer;

  border-radius: 5px;

  border: 1px solid ${({ theme }) => theme.colors.border.A};
  box-shadow: 0 1px 2px 0 ${({ theme }) => theme.colors.shadow.outer};
`

export const ArchiveBoxIcon = styled(ArchiveBoxIconUnstyled)`
  width: 24px;
  height: 24px;
  margin-right: 8px;
`
